import React from 'react';
import { LettingWidgetBase } from '../LettingWidgetBase/LettingWidgetBase';
export const InventoryListWidget = ({ onClick }) => {
    return (<LettingWidgetBase iconUrl='https://www.haven.com/assets/owners/lettings/checklist.svg' title='Inventory' isClosed={true} onClick={onClick}/>);
};
